import _ from 'lodash';

import { FeeSource, HARDCODED_FEES } from 'constants/feeTypes';

const isAppraisalFeeItem = feeName =>
  (feeName || '').toString().trim().toLowerCase() === HARDCODED_FEES.APPRAISAL_FEE.toLowerCase();

const isAppraisalSurchargeItem = fee => fee.feeSource === FeeSource.APPRAISAL_SURCHARGE;

const APPRAISAL_SURCHARGE_AMOUNT_FIELDS = [
  'amount',
  'borrowerPaidAtClosingAmount',
  'borrowerPaidBeforeClosingAmount',
];

// Folds an appraisal-surcharge fee row into its base "Appraisal Fee" row, attaching
// each surcharge as `appraisalSurcharges` on the base item instead of rendering it as
// a standalone row (STP-242). A section with surcharges but no base row is left as-is —
// this mirrors the backend's own graceful fallback in AppraisalSurchargeFeeMaterializer.
export const foldAppraisalSurcharges = (items, feeTypes) => {
  const [surchargeItems, otherItems] = _.partition(items, isAppraisalSurchargeItem);

  if (!surchargeItems.length) {
    return items;
  }

  const baseAppraisalFee = otherItems.find(item => isAppraisalFeeItem(item.feeName || item.name));

  if (!baseAppraisalFee) {
    return items;
  }

  const appraisalSurcharges = surchargeItems.map(surcharge => ({
    feeTypeId: surcharge.feeTypeId,
    feeName: surcharge.feeName || surcharge.name,
    feeTypeName: feeTypes?.[surcharge.feeTypeId]?.name,
    ..._.pick(surcharge, APPRAISAL_SURCHARGE_AMOUNT_FIELDS),
  }));

  return otherItems.map(item =>
    item === baseAppraisalFee ? { ...item, appraisalSurcharges } : item,
  );
};
